// Settings Layout

import { NavLink, Outlet } from 'react-router-dom';

const settingsNav = [
  { to: '/settings/account', label: 'Account' },
  { to: '/settings/billing', label: 'Billing' },
  { to: '/settings/users', label: 'Users' },
  { to: '/settings/organization', label: 'Organization' },
];

export function SettingsLayout() {
  return (
    <div className="max-w-6xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
      </div>

      <div className="flex gap-8">
        {/* Sidebar Navigation */}
        <nav className="w-48 flex-shrink-0">
          <ul className="space-y-1">
            {settingsNav.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `block rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Content Area */}
        <div className="flex-1">
          <div className="card">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
